import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import YouTube from 'react-youtube';
import styles from './index.scss';
import LazyImage from '../LazyImage';
import { scrolling } from '../../utils/scrolling';

let eventInPopup = false;
const getScrollingConfig = () => ({
    duration: 300,
    element: document.getElementById('scrollElement'),
});
class Popup extends React.Component {
    componentDidMount() {
        window.addEventListener('keydown', e => {
            if (e.keyCode === 27) {
                this.props.toClose();
            }
        });
    }

    scrollForSee(target) {
        const el = target;
        const parent = el.parentElement.parentElement;
        const [direction, size] = window.innerWidth > 961 ? ['Top', 'Height'] : ['Left', 'Width'];
        const scrollConfig = {
            direction,
            ...getScrollingConfig(),
        };
        const visibleArea = parent[`scroll${direction}`] + parent[`offset${size}`];
        if (el[`offset${direction}`] + el[`offset${size}`] > visibleArea) {
            scrolling({
                more: el[`offset${direction}`] + el[`offset${size}`] - visibleArea,
                ...scrollConfig,
            });
        } else if (parent[`scroll${direction}`] > el[`offset${direction}`]) {
            scrolling({
                more: el[`offset${direction}`] - parent[`scroll${direction}`],
                ...scrollConfig,
            });
        }
    }
    play(e) {
        e.target.playVideo();
    }
    render() {
        if (this.props.opened === false) {
            return null;
        }
        const activeMedia = this.props.mediaItems[this.props.activeItem];
        const url = activeMedia.url.split('?')[0];
        const urlPath = url.split('/');
        const videoId = urlPath[urlPath.length - 1];
        return (
            <div
                onClick={() => {
                    if (!eventInPopup) {
                        this.props.toClose();
                    }
                    eventInPopup = false;
                }}
                className={styles.popupWrapper}
            >
                <div
                    onClick={() => {
                        eventInPopup = true;
                    }}
                    className={styles.popup}
                >
                    <div className={styles.popupHeader}>
                        <div className={styles.headerLabel}>{this.props.title}</div>
                        <div
                            onClick={() => {
                                this.props.toClose();
                            }}
                            className={styles.toClosePopup}
                        >
                            <div className={styles.iconClosePopup} />
                        </div>
                    </div>
                    <div className={styles.popupContent}>
                        <div className={styles.popupLeftBar}>
                            <div id="scrollElement" className={styles.scrollContainer}>
                                <div className={styles.scrollContent}>
                                    {this.props.mediaItems.map((item, i) => {
                                        const classesForMediaItem = classNames({
                                            [styles.mediaItem]: true,
                                            [styles.videoItem]: item.mediaType === 'video',
                                            [styles.threeDItem]: item.mediaType === '3dModel',
                                            [styles.activeItem]: this.props.activeItem === i,
                                        });
                                        return (
                                            <div
                                                onClick={e => {
                                                    const toHand =
                                                        e.target.tagName === 'IMG'
                                                            ? e.target.parentElement
                                                            : e.target;
                                                    this.props.changeItem(i);
                                                    this.scrollForSee(toHand, i);
                                                }}
                                                key={`media-item-${i}`}
                                                className={classesForMediaItem}
                                            >
                                                {item.previewUrl &&
                                                    item.mediaType !== '3dModel' && (
                                                        <LazyImage
                                                            extendClass={styles.preview}
                                                            name={item.name}
                                                            src={item.previewUrl}
                                                        />
                                                    )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className={styles.popupMainBar}>
                            {activeMedia.mediaType !== 'video' ? (
                                <iframe
                                    src={`https://sketchfab.com/models/${activeMedia.sketchfabId}/embed?autostart=1&ui_watermark_link=0&ui_watermark=0`}
                                    allow="autoplay"
                                    allowvr="true"
                                    allowFullScreen
                                    mozallowfullscreen="true"
                                    webkitallowfullscreen="true"
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                />
                            ) : (
                                <YouTube
                                    className={styles.playerYT}
                                    containerClassName={styles.playerYT}
                                    videoId={videoId}
                                    onReady={this.play}
                                    opts={{
                                        height: '100%',
                                        width: '100%',
                                        playerVars: {
                                            autoplay: 1,
                                            rel: 0,
                                        },
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
Popup.propTypes = {
    mediaItems: PropTypes.array.isRequired,
    mediaItemsArrayOf: PropTypes.arrayOf({
        url: PropTypes.string.isRequired,
        previewUrl: PropTypes.string,
        mediaType: PropTypes.string.isRequired,
    }),
    toClose: PropTypes.func.isRequired,
    changeItem: PropTypes.func.isRequired,
    activeItem: PropTypes.number,
    opened: PropTypes.bool,
    title: PropTypes.string,
};
export default Popup;
